import { LinkPreview } from './link-preview'
import { useOpenGraphDataProxyQuery } from './queries'

export interface LinkPreviewContainerProps {
  url: string
}

export const LinkPreviewContainer = (props: LinkPreviewContainerProps) => {
  const { loading, data } = useOpenGraphDataProxyQuery({ url: props.url })

  return (
    <LinkPreview
      url={props.url}
      loading={loading}
      openGraphData={data}
    />
  )
}
